import { defaultProps } from "recompact"
import {
  Flex as OrigFlex,
  Box as OrigBox,
  ContentBox as OrigContentBox,
  ContentCell as OrigContentCell,
} from "@infotech/uikit-grid"
import withBorder from "src/hocs/withBorder"
import styles from "./styles.css"

export const Flex = withBorder(OrigFlex)
export const Box = withBorder(OrigBox)
export const ContentBox = withBorder(OrigContentBox)
export const ContentCell = withBorder(OrigContentCell)
export const FlatContentBox = defaultProps({
  className: styles.FlatContentBox,
})(ContentBox)
export const FormRow = defaultProps({
  className: styles.FormRow,
})(Box)
